import { capitalize, lowerCase } from 'lodash-es';

/**
 * Formats a workflow parameter key for overlay labels (sentence case, spaced words).
 *
 * @example humanizeParameterName('patientName') => 'Patient name'
 * @example humanizeParameterName('original_time') => 'Original time'
 * @example humanizeParameterName('EMRPatientId') => 'Emr patient id'
 */
export function humanizeParameterName(name: string): string {
  if (!name) return '';
  return capitalize(lowerCase(name));
}
